/**
 * Wells Fargo payment calculator plan matching (ported from Hydrogen wells-fargo-payment.ts).
 */
(function (global) {
  function matchPlans(availablePlans, productprice) {
    return availablePlans
      .map(function (item) {
        if (item.OPERATE === 'under' && parseFloat(productprice) < parseFloat(item.RANGES)) {
          return {plan_number: item.CODE.toString(), item_range: item.RANGES};
        }
        if (item.OPERATE === 'above' && parseFloat(productprice) > parseFloat(item.RANGES)) {
          return {plan_number: item.CODE.toString(), item_range: item.RANGES};
        }
        return null;
      })
      .filter(Boolean);
  }

  function resolveDefaultPlanId(availablePlans, filteredPlans) {
    if (!filteredPlans.length) return '';
    const validPlans = filteredPlans.map(function (item) {
      return item.item_range;
    });
    const isDuplicate = validPlans.some(function (item, idx) {
      return validPlans.indexOf(item) !== idx;
    });
    if (isDuplicate) {
      const findDefault = availablePlans.filter(function (item) {
        return item.DEFAULT === true;
      });
      const allCodes = findDefault.map(function (item) {
        return item.CODE.toString();
      });
      if (allCodes[0]) return allCodes[0];
    }
    const last = filteredPlans[filteredPlans.length - 1];
    return last ? last.plan_number : '';
  }

  function buildWellsFargoCalculations(availablePlans, productPriceRounded) {
    return availablePlans.map(function (item) {
      return {
        plan_number: item.CODE.toString(),
        financed_amount: productPriceRounded,
        client_unique_id: 'RDJ' + item.CODE,
      };
    });
  }

  function getWellsFargoPayCalcPayload(calcAmount, planRoot) {
    const plans = (planRoot && planRoot.wellsfargo && planRoot.wellsfargo.Plans
      ? planRoot.wellsfargo.Plans
      : []
    ).filter(function (p) {
      return p.apr === '0';
    });
    if (!plans.length) return null;
    const productprice = Math.round(calcAmount).toString();
    const filteredPlans = matchPlans(plans, productprice);
    const calculations = buildWellsFargoCalculations(plans, productprice);
    if (!calculations.length) return null;
    return {
      calculations: calculations,
      defaultPlanId: resolveDefaultPlanId(plans, filteredPlans) || '',
    };
  }

  function formatWellsFargoTaglineHtml(raw, isDesktop) {
    var product1Tagline = raw
      .replace(/(<|&lt;)br\s*\/*(>|&gt;)/gi, ' ')
      .replace(/payment\$/i, 'payment $')
      .replace(/per month(?!s)/i, 'per month <sup>[2]</sup>');
    var monthsLabel = '<strong class="wells-fargo-financing__months">months</strong> <sup>[1]</sup>';
    var tail = isDesktop ? ' <br>(' : '(';
    if (/months\s*[(]/i.test(product1Tagline)) {
      return product1Tagline.replace(/\s*months\s*[(]/i, ' ' + monthsLabel + tail);
    }
    return product1Tagline.replace(/[(]/, monthsLabel + tail);
  }

  global.WellsFargoPayment = {
    getWellsFargoPayCalcPayload: getWellsFargoPayCalcPayload,
    formatWellsFargoTaglineHtml: formatWellsFargoTaglineHtml,
  };
})(window);
